import { css } from "lit";
export const styles = css `
  :host {
    --font-size: 0.875rem;
    --font-family: Manrope, Arial, sans-serif;

    --bender-white: #ffffff;
    --bender-black: #000000;

    --bender-yellow-minus-1: #e2ab00;
    --bender-yellow-0: #ffc100;
    --bender-yellow-1: #ffd360;
    --bender-yellow-2: #ffe091;
    --bender-yellow-3: #ffefca;
    --bender-yellow-4: #fff4df;
    --bender-grey-minus-1: #1d1d1d;
    --bender-grey-0: #3a3a3a;
    --bender-grey-1: #4e4e4e;
    --bender-grey-2: #616161;
    --bender-grey-3: #757575;
    --bender-grey-4: #898989;
    --bender-grey-5: #9f9f9f;
    --bender-grey-6: #b5b5b5;
    --bender-grey-7: #cbcbcb;
    --bender-grey-8: #e1e1e1;
    --bender-grey-9: #ebebeb;
    --bender-grey-10: #f6f6f6;

    --bender-state-red: #e80000;
    --bender-state-yellow: var(--bender-yellow-0);
    --bender-state-green: #009306;
    --bender-state-blue: #00a7ef;
    --bender-state-grey: var(--bender-grey-4);

    --bender-illustration-green: #007a3b;
    --bender-illustration-blue: #00549d;
    --bender-illustration-cyan: #64d0da;
    --bender-illustration-grey: var(--bender-grey-4);
    --bender-illustration-red: #ed1c29;
    --bender-illustration-rose: #f88e98;
    --bender-illustration-bender-yellow: var(--bender-yellow-0);
    --bender-illustration-yellow: #fdfa00;
    --bender-illustration-purple: #6a289b;
    --bender-illustration-brown: #523400;

    --bender-hover: var(--custom-primary-color, var(--bender-grey-8, #e1e1e1));
    --bender-selected: var(--bender-grey-7);

    --header-height: 64px;
    --border-radius: 3px;
    font-family: var(--font-family);
    font-size: var(--font-size);
    font-weight: 400;
  }

  [hidden] {
    display: none !important;
  }

  a {
    color: var(--custom-primary-color, var(--bender-yellow-minus-1, #e2ab00));
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }

  .btn {
    box-sizing: border-box;
    border-width: 2px;
    border-style: solid;
    color: inherit;
    background: none;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    vertical-align: middle;
    -webkit-user-select: none;
    user-select: none;
    cursor: pointer;
    outline: none;
    -webkit-appearance: none;
    position: relative;
    transition:
      color 0.2s ease-in-out,
      background-color 0.2s ease-in-out,
      border-color 0.2s ease-in-out,
      box-shadow 0.2s ease-in-out;
    padding-block: 0.375rem;
    padding-inline: 0.75rem;
    border-radius: 0.375rem;
  }

  .btn.btn-default {
    border-color: #ededed;
    color: #212529;
    background-color: #ededed;
  }

  .btn.btn-sm {
    padding-block: 0.2rem;
    padding-inline: 0.55rem;
  }

  button {
    cursor: pointer;
    font-family: inherit;
    font-size: var(--font-size);
  }

  .dropdown-content {
    z-index: 10000;
    position: absolute;
    background: #ffffff;
    top: var(--header-height);
    right: 0;
    padding: 10px;
    text-align: start;
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.25);
  }

  .display-name {
    margin-bottom: 0.4rem;
    text-align: center;
  }
  .profile-container .dropdown-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 240px;
    padding-top: 25px;
    gap: 16px;
  }
  .profile-info-container {
    display: flex;
    flex-direction: column;
  }

  .tenant-container {
    display: flex;
    flex-direction: column;
    text-align: center;
    gap: 0.5rem;
    margin-bottom: 8px;

    .btn {
      font-weight: bold;
      border-radius: var(--border-radius);
      min-width: 138px;
    }
  }

  .tooltip-tenant {
    display: none;
    position: absolute;
    width: max-content;
    top: -26px;
    left: 50%;
    transform: translateX(-50%);
    background: var(--bender-grey-0);
    color: white;
    padding: 2px 8px;
    box-shadow: 0px 2px 4px 0px #00000040;

    &:after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      border-width: 5px;
      border-style: solid;
      border-color: var(--bender-grey-0) transparent transparent transparent;
    }
  }

  .tenant-name {
    position: relative;
    cursor: default;
    color: var(--bender-grey-6);
    display: block;

    &:hover .tooltip-tenant {
      display: block;
    }
  }

  .dropdown-content-list {
    display: flex;
    flex-direction: column;
    gap: 7px;
    width: 100%;
  }

  span:has(.dropdown-item) {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }

  .dropdown-item {
    cursor: pointer;
    border: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: var(--bender-grey-0);
    padding: 5px 8px;

    &:hover {
      background-color: var(--bender-hover);
      text-decoration: none;
      border-radius: var(--border-radius);
      color: var(--custom-contrast-color, var(--bender-grey-0, #3a3a3a));
      path {
        fill: var(--custom-contrast-color, var(--bender-grey-0, #3a3a3a));
      }
    }
  }

  .icon-text-container {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .divider {
    width: 100%;
    border: 0;
    border-top: 1px solid var(--bender-grey-8);
    margin: 0;
  }

  .switch-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    max-width: 300px;
    flex-wrap: wrap;
    gap: 30px 20px;

    .app-link {
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: var(--bender-grey-0);
      text-decoration: none;
      flex-grow: 1;
      gap: 2px;
      min-width: 100px;
      padding: 5px 10px;
      border-radius: var(--border-radius);

      &:hover {
        background-color: var(--bender-hover);
        color: var(--custom-contrast-color, var(--bender-grey-0, #3a3a3a));
        text-decoration: none;
        path {
          fill: var(--custom-contrast-color, var(--bender-grey-0, #3a3a3a));
        }
      }

      > div:first-child {
        width: 44px;
        height: 44px;
      }
    }
  }

  .switch-header {
    text-align: center;
    color: var(--bender-grey-4);
    padding-bottom: 1.5rem;
    padding-top: 0.5rem;
  }

  .switch-footer {
    border-top: 1px solid var(--bender-grey-8);
    margin-top: 1.5rem;
    padding-top: 5px;

    .footer-icon {
      width: 24px;
      height: 24px;
    }

    a {
      display: flex;
      align-items: center;
      line-height: 1px;
      color: var(--bender-grey-0);
      grid: 20px;
    }
  }

  .app-link.disabled,
  .disabled {
    color: var(--bender-grey-4);
    pointer-events: none;

    svg {
      opacity: 0.5;
    }
  }

  .menu-row {
    display: flex;
    height: var(--header-height);
    justify-content: space-between;
    align-items: center;
    padding-inline: 1rem;
    padding-block: 0;
    gap: 1rem;
  }
  .top-bar {
    background-color: var(--custom-top-bar-background-color, var(--bender-yellow-0));
  }
  .top-bar__logo {
    width: auto;
    height: 45px;
  }

  .app-logo {
    display: flex;
    gap: 10px;
    align-items: flex-end;
    margin-left: 1rem;
    min-width: 0;

    img {
      max-width: 120px;
      max-height: 45px;
      vertical-align: middle;
    }

    a {
      text-decoration: none;
      color: var(--custom-contrast-color, var(--bender-grey-0));
    }

    .app-logo-text {
      font-size: 1.5rem;
      font-weight: 600;

      white-space: nowrap;
      display: flex;
      align-items: baseline;
      min-width: 0;
    }

    .app-logo-subtext {
      color: var(--custom-contrast-color, var(--bender-grey-0));
      font-size: var(--custom-claimtext-size, 1.1rem);
      font-weight: 400;
      margin-left: 0.75rem;

      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      display: block;
    }
  }

  @media (max-width: 576px) {
    .app-logo {
      align-items: center;
      gap: 6px;
      margin-left: 0;

      img {
        max-width: 120px;
        height: 34px;
        vertical-align: middle;
      }

      .app-logo-text {
        display: flex;
      }

      .app-logo-maintext {
        font-size: 1.15rem;
      }
      .app-logo-text:has(.app-logo-subtext) .app-logo-maintext {
        display: none;
      }

      .app-logo-subtext {
        color: var(--custom-contrast-color, var(--bender-grey-0));
        font-size: var(--custom-claimtext-size, 0.875rem);
        font-weight: 600;
        margin-left: 0;
      }
    }
  }

  .menu-items {
    display: flex;
    align-self: center;
    align-items: center;
    gap: 0.75rem;
  }

  .search {
    color: #3f3d39;
    cursor: pointer;
    text-decoration: none;
    display: flex;
    align-items: center;
    margin-right: 10px;
    margin-bottom: 5px;
  }

  .hidden {
    display: none;
  }

  .notification-number {
    position: absolute;
    right: -4px;
    bottom: -2px;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    color: white;
    font-size: 0.8rem;
    background-color: #cb3535;
    text-align: center;
    pointer-events: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: 2px solid var(--bender-yellow-0);
  }

  th {
    padding: 10px 15px;
    text-align: left;
  }

  table > tbody > tr > td {
    padding: 10px 5px;
    border-bottom: 1px solid var(--bender-grey-8);
  }

  table > tbody > tr:last-child > td {
    border-bottom: none;
  }

  .notification-container {
    position: relative;
  }

  .notification-container .dropdown-content {
    min-width: 450px;
    max-width: 750px;
    padding: 10px 15px;
  }

  .notification-container .dropdown-content .empty-state {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 10px;
    color: var(--bender-grey-6);
  }

  .notification-table {
    width: 100%;
    border-collapse: collapse;
  }

  .notification-table thead > tr {
    border-bottom: 1px solid #000000;
  }

  .notification-table .severity {
    text-align: center;
  }

  .notification-table .severity svg.icon {
    width: 28px;
    height: 28px;
  }

  .notification-category span {
    color: #fff;
    background-color: var(--bender-grey-7);
    padding: 0 4px;
    border-radius: 12px;
    font-size: 11px;
  }

  svg.icon {
    width: 18px;
    height: 18px;
    vertical-align: middle;
  }

  .icon-link svg.icon {
    width: 12px;
    height: 12px;
    margin-left: 3px;
  }

  .header-btn {
    background: none;
    border: none;
    display: flex;

    svg path {
      fill: var(--custom-contrast-color, var(--bender-grey-0, #3a3a3a));
    }
  }

  .profile-initials {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: var(--custom-primary-color, #ffffff);
    background-color: var(--custom-contrast-color, var(--bender-grey-0, #3a3a3a));
    font-weight: bold;
  }

  .profile-image {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    align-self: center;
  }

  .profile-container .header-btn .profile-image {
    border: 2px solid #ffffff;
    background-color: #ffffff;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.25);
  }

  .profile-info-container .profile-image,
  .profile-info-container .profile-initials {
    width: 104px;
    height: 104px;
    margin: 15px 0 20px;
    outline: 2px solid var(--bender-grey-8);
    outline-offset: 3px;
    font-size: 4rem;
  }

  .profile-info-container .profile-initials {
    align-self: center;
    background-color: var(--custom-contrast-color, var(--bender-grey-6, #898989));
    color: var(--custom-primary-color, #ffffff);
  }

  .header-btn .profile-initials {
    color: var(--custom-primary-color, var(--bender-yellow-0, #ffc100));
    width: 28px;
    height: 28px;
  }

  .header-btn svg.icon {
    fill: var(--custom-contrast-color, var(--bender-grey-0, #3a3a3a));
    width: 26px;
    height: 26px;
  }
  .dropdown-background {
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 9999;
  }
  @media (max-width: 425px) {
    .profile-container .dropdown-content {
      box-sizing: border-box;
      width: 100%;
      right: 0;
    }
  }
`;
//# sourceMappingURL=styles.js.map